module.exports = __webpack_public_path__ + "static/media/juntos-app-phone.f030ce45.svg";